export default __webpack_public_path__ + "static/media/chicago.gov-logo.ccac651b.png";